import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

export const EmptyState: React.FC<{
  title: string
  buttonText?: string
  description: string
  onClick?: () => void
  disabled?: boolean
  hasCTAButton?: boolean
}> = ({ title, buttonText, description, onClick, disabled = false, hasCTAButton = true }) => {
  return (
    <Box alignItems="center" gap="s16" padding="s32">
      <Icon.Large icon="document-folder-drawer-2" color="radicalRed1000" />
      <Box gap="s16" textAlign="center" alignItems="center">
        <Text.Header2 color="grey800" weight="semibold">
          {title}
        </Text.Header2>
        <Text.Normal color="grey800">{description}</Text.Normal>
        {hasCTAButton && (
          <Box padding="s16">
            <Button disabled={disabled} onClick={() => onClick && onClick()}>
              {buttonText}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}
